/* global moment: false, $: false */
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './components/App.vue'
import './components/App.sass'
import WechatJS from '@/plugins/wechat-sdk'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

let inited = false
const init = () => {
  if (!inited) {
    inited = true
    moment.locale('zh-cn')
    Vue.use(WechatJS)
    new Vue({
      router,
      store, // inject store to all children
      el: '#app',
      render: h => h(App)
    })
  }
}

// 如果 cdn 炸裂
const deps = [{
  defined: () => { return typeof moment !== 'undefined' },
  src: '/static/js/moment-with-locales.min.js'
}, {
  defined: () => { return typeof $ !== 'undefined' },
  src: '/static/js/jquery-3.1.1.min.js'
}]
const checkDepsAndInit = () => {
  let allDefined = true
  for (let i = 0; i < deps.length; i++) {
    const dep = deps[i]
    if (!dep.defined()) {
      allDefined = false
      break
    }
  }
  if (allDefined) {
    init()
  }
}
const head = document.getElementsByTagName('head')[0]
const appendScript = src => {
  const script = document.createElement('script')
  head.appendChild(script)
  script.onload = checkDepsAndInit
  script.src = src
}
for (let i = 0; i < deps.length; i++) {
  const dep = deps[i]
  if (!dep.defined()) {
    appendScript(dep.src)
  }
}

checkDepsAndInit()



// WEBPACK FOOTER //
// ./src/index.js